import * as VritraElement from "./VritraElement";


export default {
    id:"View",
    parent:"HTMLElement",
    type:"(props:object):View",
    props:[
        {
            name:"parent",
            type:"HTMLElement",
            description:"The element in which the view will be inserted",
        },
        VritraElement.atProp,
        {
            name:"id",
            type:"string",
            description:"the view id attribute value",
        },
        {
            name:"className",
            type:"string|string[]",
            description:"the view class attribute value",
        },
        {
            name:"style",
            type:"string|CSSStyleDeclaration|[string|CSSStyleDeclaration][]",
            description:"the view style attribute value",
        },
        {
            name:"tag",
            type:"string",
            defaultValue:"div",
        },
    ],
    methods:[
        VritraElement.innateHTML,
        {
            name:"beforeEndHTML",
            type:"string",
            description:"inserts safely HTML or XML markup at the end of the element"
        },
        {
            name:"afterBeginHTML",
            type:"string",
            description:"inserts safely HTML or XML markup at the beginning of the element",
        },
        {
            name:"adjacentTo",
            type:"(element:Element,before?:boolean):View",
            description:"Inserts the view before or after an element and returns the current view",
            props:[
                {
                    name:"element",type:"Element",
                    description:"Element before/after which the view is inserted",
                },
                {
                    name:"before",type:"boolean",
                    description:"if true the view is inserted before the element otherwise after. @default to false",
                },
            ],
        },
        VritraElement.queryAllSelectors,
        {
            name:"substitute",
            type:"(substitute:Node):Node",
            description:"replaces the view by another node and returns the substitute",
            notice:`
                only use it when the view is no longer required 
                and it's not gonna be cached for later use
            `,
        },
    ],
};
